export default __webpack_public_path__ + "static/media/reception.8bbfca23.jpg";